import { useEffect, useRef } from "react";
import { recordVisit, setContext, track } from "./index";

// tp_page_view on mount and tp_page_time (active seconds, excluding hidden time)
// when the page unmounts or the tab is closed. `awb` sets the shared context first,
// so the view event already carries it; `visit_number` counts views of that AWB on
// this device.
const usePageView = (page, { awb } = {}) => {
  const sent = useRef(false);

  useEffect(() => {
    if (awb) setContext({ awb });
    track("tp_page_view", { page, ...recordVisit(awb) });

    const start = Date.now();
    let active = 0;
    let since = document.hidden ? null : start;
    let hiddenCount = 0;

    const onVisibility = () => {
      if (document.hidden) {
        hiddenCount += 1;
        if (since !== null) active += Date.now() - since;
        since = null;
      } else if (since === null) since = Date.now();
    };

    const finish = () => {
      if (sent.current) return;
      sent.current = true;
      if (since !== null) active += Date.now() - since;
      track("tp_page_time", { page, active_seconds: Math.round(active / 1000), hidden_count: hiddenCount });
    };

    document.addEventListener("visibilitychange", onVisibility);
    window.addEventListener("pagehide", finish);
    return () => {
      document.removeEventListener("visibilitychange", onVisibility);
      window.removeEventListener("pagehide", finish);
      finish();
    };
    // One view per mount; the page name does not change while mounted.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);
};

export default usePageView;
